export enum PharmacyRequestStatus {
  Pending = 510101,
  InProgress = 510103,
  Accepted = 510107,
  Expired = 510109,
  Rejected = 510108,
  Cancelled = 510102,
  Feedback = 510105,
}

export interface ActionItem {
  titleEn: string;
  titleAr: string;
  action: string;
}
